import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_punhnqvhh6: FaireBrandEntity = {
  token: "b_punhnqvhh6",
  type: "brand",
  name: "CRAVE",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ed6f7adb2b6f842a7f632e280e79a57db87e324ce15061ddb73b1fc2fcaf548.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f913f22abfe5cc5808985ddab2c4b4174540e696d9e50c7c14d21a7dda9b979e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0ed6f7adb2b6f842a7f632e280e79a57db87e324ce15061ddb73b1fc2fcaf548.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f913f22abfe5cc5808985ddab2c4b4174540e696d9e50c7c14d21a7dda9b979e.png",
  location: "PARAMOUNT, CA, USA",
  minimumOrderDollars: 83,
  rating: 4.8,
  reviewCount: 176,
  isTopShop: true,
  isInsider: true,
  description:
    "Since 2004, CRAVE Body Jewelry has been a leader in wholesale body piercing jewelry across the United States. We serve professionals of all experience levels, from beginners to seasoned experts.\n\nOur focus is on providing high-quality products and staying updated with the latest trends. We offer a variety of items, including pre-made display cases with carefully selected jewelry, as well as individual pieces and sets. Our goal is to offer these popular items at competitive prices.\n\nQuality is essential to us. Every piece of body jewelry comes with a certificate ensuring its excellence. We also have clear policies for warranties, exchanges, and returns, aiming to provide outstanding customer service.\n\nWhether you have a kiosk, a tattoo or piercing shop, a store, a website, or a gift shop, CRAVE Body Jewelry is here to help you find the right jewelry for your business. We are passionate about body jewelry and are committed to offering you the latest trends in the industry.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:53.623Z",
    importedBy: "entity-db-cli",
  },
};
